// ─── Settings editor helpers (X5-p) ───────────────────────────────────────────
//
// Pure functions, kept out of SettingsTab.jsx so that file only exports
// components (react-refresh) and so these are unit-testable on their own —
// they are where a wrong type would silently turn a number into a string on
// the wire.

/**
 * The editor is picked from the *default's* type, not the current value's:
 * the registry (backend-nest settings.registry.ts) fixes each key's type and
 * the default is always of that type, while a stored override could in theory
 * be anything an older build accepted.
 */
export function kindOf(value) {
  if (typeof value === 'boolean') return 'boolean'
  if (typeof value === 'number') return 'number'
  if (typeof value === 'string') return 'string'
  return 'json'
}

/** What the editor shows for a value: JSON for objects/arrays, the value itself otherwise. */
export function toEditorText(kind, value) {
  if (kind === 'json') return JSON.stringify(value ?? null, null, 2)
  if (kind === 'boolean') return value ? 'true' : 'false'
  return value === null || value === undefined ? '' : String(value)
}

/**
 * The editor's text back into the value the API expects. Throws a Persian
 * message for what cannot be sent at all (a non-number, invalid JSON); the
 * backend still validates against the key's schema and answers 422 for the
 * rest.
 */
export function fromEditorText(kind, text) {
  if (kind === 'boolean') return text === 'true'
  if (kind === 'number') {
    const n = Number(text.trim())
    if (text.trim() === '' || Number.isNaN(n)) throw new Error('عدد معتبر وارد کن.')
    return n
  }
  if (kind === 'string') return text
  try { return JSON.parse(text) }
  catch { throw new Error('JSON معتبر نیست.') }
}
